module.exports = __webpack_public_path__ + "static/img/zt@2x.ab1f52d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zt@2x.png
// module id = Xb4d
// module chunks = 2